/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectivity_History_RebootsInputs */



/**
* | output |
* | --- |
* | "Probable reboots" |
*
* @param {Connectivity_History_RebootsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const connectivity_history_reboots = /** @type {((inputs?: Connectivity_History_RebootsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectivity_History_RebootsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Probable reboots")
	return /** @type {LocalizedString} */ ("Redémarrages probables")
});